export default "__VITE_ASSET__29cf63c9__"